<template>
	<IconCommon
		:icon-name="iconName"
		:icon-fallback="iconFallback"
		:size="size"
		:background="background"
		:class="{ 'icon--block': !inline }"
		@click="$emit('click', $event)"
	/>
</template>

<script>

import IconCommon from '@shared/components/Icon';

export default {
	name:       'IconV2',
	components: { IconCommon },
	props:      {
		iconName: {
			type:     String,
			required: true,
		},
		iconFallback: {
			type:     String,
			required: false,
			default:  null,
		},
		size: {
			type:    String,
			default: 'lg',
		},
		background: {
			type:     String,
			required: false,
			default:  null,
		},
		inline: {
			type:    Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.v2-icon {
	line-height: 0;
}

.icon--block {
	display: block;
}
</style>
